// /components/ContactForm.js
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { translations } from "../translations"; // Importer les traductions
import config from "../config";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    firstname: "",
    mailclt: "",
    tel: "",
    message: "",
  });

  const [status, setStatus] = useState(null);
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'fr'; // Extraire la langue de l'URL
  const t = translations[currentLang].contactForm; // Sélectionner les traductions appropriées

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "message" && value.length > 500) return;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(t.sending); // Afficher "Envoi en cours..." ou l'équivalent en anglais

    try {
      const response = await fetch(`${config.API_BASE_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus(t.successMessage); // Afficher le message de succès
        setFormData({
          name: "",
          firstname: "",
          tel: "",
          mailclt: "",
          message: "",
        });
      } else {
        setStatus(t.errorMessage); // Afficher l'erreur d'envoi
      }
    } catch (error) {
      setStatus(t.connectionError); // Afficher l'erreur de connexion
    }
  };

  // 🔥 Effet pour masquer le statut après 5 secondes
  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => {
        setStatus(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  return (
    <div className="flex flex-col items-center py-12 w-full " id="contact">
      {/* Message de statut */}
      {status && (
        <div className="bg-deepblue text-white px-4 py-2 rounded-lg shadow-md mb-4 transition-opacity duration-500">
          {status}
        </div>
      )}

      <h3 className="text-2xl font-semibold text-black mb-6">{t.title}</h3>

      <form
        onSubmit={handleSubmit}
        className="w-11/12 md:w-2/3 lg:w-1/2 bg-light p-8 rounded-2xl shadow-lg flex flex-col space-y-4"
      >
        {/* Nom & Prénom */}
        <div className="flex space-x-4">
          <input
            type="text"
            name="name"
            placeholder={t.namePlaceholder}
            value={formData.name}
            onChange={handleChange}
            required
            className="w-1/2 p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
          />
          <input
            type="text"
            name="firstname"
            placeholder={t.firstnamePlaceholder}
            value={formData.firstname}
            onChange={handleChange}
            required
            className="w-1/2 p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
          />
        </div>

        {/* Téléphone */}
        <input
          type="tel"
          name="tel"
          placeholder={t.telPlaceholder}
          value={formData.tel}
          onChange={handleChange}
          required
          pattern="[0-9]{10}"
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
        />

        {/* Email */}
        <input
          type="email"
          name="mailclt"
          placeholder={t.emailPlaceholder}
          value={formData.mailclt}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
        />

        {/* Message */}
        <textarea
          name="message"
          placeholder={t.messagePlaceholder}
          value={formData.message}
          onChange={handleChange}
          required
          maxLength="500"
          className="w-full p-3 border rounded-lg h-32 resize-none focus:outline-none focus:ring-2 focus:ring-accent"
        />

        {/* Bouton Envoyer */}
        <button
          type="submit"
          className="w-full bg-accent text-white p-3 rounded-lg font-semibold hover:bg-gray-800 transition duration-300"
        >
          {t.sendButton}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
